module.exports = __webpack_public_path__ + "img/folder-dark-pink.5502964c.svg";